import {Component, computed, input} from '@angular/core';
import {toWorkflowTagText} from '../../../util/app.types';

/**
 * The pill naming a workflow note (Submission note, Reason withheld, ...). Runs inline at the head
 * of the note in its bubble, and sits above the editor while the note is being edited - there the
 * text is inside an input, so there is no line for it to share.
 *
 * align-middle so the smaller label centres against the comment's text; left on the shared baseline
 * it rides high, the pill's cap above the text's.
 *
 * One colour on either bubble: the pill says what kind of note this is, which is the same fact
 * whoever wrote it, so it does not follow the bubble's side the way the mentions do.
 */
@Component({
  selector: 'ta-workflow-tag',
  template: `<span class="inline-flex items-center rounded-full px-2 py-px text-[10px] font-['Inter'] leading-4 whitespace-nowrap select-none align-middle bg-purple-200 text-surface-800">{{ label() }}</span>`,
})
export class TaWorkflowTagComponent {
  /** The key from the comment's `#[workflow](key)` tag. */
  key = input.required<string>();

  protected label = computed<string>(() => toWorkflowTagText(this.key()));
}
